<section class="mn_map_view">
  <div class="contmap" style="overflow: hidden;">
    <google-map [center]="center" [zoom]="zoom" [options]="options" height="100%" width="100%">
      <map-marker [position]="markerPosition"></map-marker>
    </google-map>
  </div>
</section>